var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryParent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/choose category Copy 15@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-V3-Account---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Influencer-view_Instagram-Copy-2-(2)",
    transform: "translate(-622.000000, -850.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(585.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.000000, 167.000000)",
    id: "eco-home"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.695652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0.304695652 L1.73913043,5.42608696 L1.73913043,14.6086957 C1.73913043,14.9928937 2.05058452,15.3043478 2.43478261,15.3043478 L13.5652174,15.3043478 C13.9494155,15.3043478 14.2608696,14.9928937 14.2608696,14.6086957 L14.2608696,5.42608696 L8,0.304695652 Z",
    id: "Path",
    fill: "#EAD8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6521739,6.95652174 C15.5720306,6.95642665 15.4943788,6.92865876 15.4323478,6.87791304 L8,0.797217391 L0.568,6.87791304 C0.419080446,6.99594078 0.203001329,6.97261257 0.0827045665,6.82551984 C-0.0375921964,6.67842712 -0.0175791516,6.46201578 0.127652174,6.33947826 L7.77982609,0.0786086957 C7.90792338,-0.0261325014 8.09207662,-0.0261325014 8.22017391,0.0786086957 L15.8723478,6.33947826 C15.9861327,6.43256213 16.02911,6.58713015 15.9797052,6.72558864 C15.9303003,6.86404713 15.7991827,6.95652174 15.6521739,6.95652174 Z",
    id: "Path",
    fill: "#E86C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.024,6.01043478 C10.9532666,5.9408108 10.8558164,5.90528209 10.7568696,5.91304348 C10.6292174,5.92243478 7.60869565,6.15930435 6.36278261,7.40521739 C4.83686957,8.93113043 5.552,11.1457391 5.58330435,11.2393043 C5.61844066,11.3450535 5.7021169,11.4275658 5.80834783,11.4612174 C6.23590614,11.5832269 6.67850625,11.644465 7.12313043,11.6431304 C8.05668519,11.6734747 8.96304232,11.3261297 9.63721739,10.6796522 C10.997913,9.32173913 11.1252174,6.39791304 11.1304348,6.27443478 C11.1342369,6.17528159 11.0955105,6.0792248 11.024,6.01043478 Z",
    id: "Path",
    fill: "#72C472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52173913,12.8695652 C4.38107969,12.8695652 4.25428381,12.7847904 4.20045983,12.6548364 C4.14663586,12.5248823 4.17637986,12.3753023 4.27582609,12.2758261 L7.75408696,8.79756522 C7.89056657,8.6657488 8.10750775,8.66763396 8.24167603,8.80180223 C8.3758443,8.93597051 8.37772946,9.15291169 8.24591304,9.2893913 L4.76765217,12.7676522 C4.70243731,12.8328867 4.6139808,12.8695652 4.52173913,12.8695652 L4.52173913,12.8695652 Z",
    id: "Path",
    fill: "#4DA34D"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryParent);
export default __webpack_public_path__ + "static/media/category_parent.f29c53825ee31cf5cf811c98f8a6e176.svg";
export { ForwardRef as ReactComponent };